import { TechnologyListResource, TechnologyResource } from "@/api/generated-api";

export const formattedTechnologies = (technologies: TechnologyListResource): TechnologyResource[] => {
  return technologies.technologies;
};
